// extracted by mini-css-extract-plugin
module.exports = {"text":"confirm_modal-module_text_cff0b","modal":"confirm_modal-module_modal_90f6c"};